import { Sun, Moon, Monitor, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTheme } from "@/components/theme-provider";

const MODES = [
	{ value: "light", label: "Sáng", icon: Sun },
	{ value: "dark", label: "Tối", icon: Moon },
	{ value: "system", label: "Hệ thống", icon: Monitor },
] as const;

export function ModeToggle() {
	const { theme, setTheme } = useTheme();

	const activeMode = MODES.find((mode) => mode.value === theme) ?? MODES[2];
	const ActiveIcon = activeMode.icon;

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					variant="outline"
					size="sm"
					aria-label={`Giao diện: ${activeMode.label}`}
					title={`Giao diện: ${activeMode.label}`}
					className="flex items-center gap-2 bg-transparent"
				>
					<ActiveIcon className="h-4 w-4" />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end">
				{MODES.map((mode) => {
					const Icon = mode.icon;
					const isActive = mode.value === theme;

					return (
						<DropdownMenuItem
							key={mode.value}
							onSelect={() => setTheme(mode.value)}
							className="flex items-center gap-2"
						>
							<Icon className="h-4 w-4" />
							<span className="flex-1">{mode.label}</span>
							{isActive && <Check className="h-4 w-4" />}
						</DropdownMenuItem>
					);
				})}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
